import dayjs from 'dayjs'
import { formatCurrencyWithRuppee } from 'utils/formatCurrency'

export const formatterFunction = ({
  type,
  value,
  dateFormat,
  showRupeeSymbol = true
}: {
  type: 'amount' | 'name' | 'date'
  value: string | number
  dateFormat?: 'DD MMM' | 'DD MMM, hh:mm A' | 'DD MMM YYYY'
  showRupeeSymbol?: boolean
}) => {
  if (type === 'amount') {
    return `${showRupeeSymbol ? '₹' : ''}` + formatCurrencyWithRuppee(value)
  }

  if (type === 'date') {
    return dayjs.unix(Number(value)).format(dateFormat || 'DD MMM YYYY')
  }

  return value
}
